import React from 'react'
//import PropTypes from 'prop-types'
// Utilities
import kebabCase from 'lodash/kebabCase'
import Seo from '../../components/Seo'
import Nav from '../../components/Nav'
import Link from 'gatsby-link'
class TagsPage extends React.Component {
  render() {
    const moment = require("moment")
    const now = moment(new Date());
    const { data } = this.props
    const { group } = data.allMarkdownRemark;
    //const facebook = (((data || {}).site || {}).siteMetadata || {}).facebook
    const config = require('../../../content/meta/config')
    const d = {
      title: 'All tags at ' + config.shortSiteTitle,
      description: 'All tags at ' + config.shortSiteTitle,
      image: config.siteImage,
      url: config.siteUrl + '/tags',
      keywords: config.resumeKeywords,
      datePublished: "2018-07-01",
      dateUpdated: now.format("YYYY-MM-DD")
    }
    return (
      <div>
        <Seo pageType='tagshow' data={d} />
        <Nav />
        <div>
          <h2>All Tags</h2>
          <ul>
            {group.map(tag => (
              <li key={tag.fieldValue}>
                <Link to={`/tags/${kebabCase(tag.fieldValue)}/`}>
                  {tag.fieldValue} ({tag.totalCount})
            </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    )
  };
}

// TagsPage.propTypes = {
//   data: PropTypes.shape({
//     allMarkdownRemark: PropTypes.shape({
//       group: PropTypes.arrayOf(
//         PropTypes.shape({
//           fieldValue: PropTypes.string.isRequired,
//           totalCount: PropTypes.number.isRequired,
//         }).isRequired
//       ),
//     }),
//     site: PropTypes.shape({
//       siteMetadata: PropTypes.shape({
//         title: PropTypes.string.isRequired,
//       }),
//     }),
//   }),
// }

export default TagsPage

export const pageQuery = graphql`
  query TagsQuery {
    site {
      siteMetadata {
        title
        facebook {
          appId
        }
      }
    }
    allMarkdownRemark(limit: 2000) {
      group(field: frontmatter___tags) {
        fieldValue
        totalCount
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/tags/index.js